import { render, staticRenderFns } from "./comestaffband.vue?vue&type=template&id=ea82bdc2&scoped=true"
import script from "./comestaffband.vue?vue&type=script&lang=js"
export * from "./comestaffband.vue?vue&type=script&lang=js"
import style0 from "./comestaffband.vue?vue&type=style&index=0&id=ea82bdc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea82bdc2",
  null
  
)

export default component.exports